import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { getStoredConsent } from "@/lib/gtag";

export const StickyBookBar = () => {
  // While the cookie banner is undecided it occupies the bottom of the screen,
  // so the bar stays hidden until the visitor makes a choice.
  const [hidden, setHidden] = useState(() => !getStoredConsent());

  useEffect(() => {
    const onDecided = () => setHidden(false);
    window.addEventListener("consent-decided", onDecided);
    return () => window.removeEventListener("consent-decided", onDecided);
  }, []);

  return (
    <div
      data-testid="sticky-book-bar"
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur-md border-t border-rose-100 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] transition-transform duration-300 ${
        hidden ? "translate-y-full" : "translate-y-0"
      }`}
    >
      <Link
        to="/marcacao"
        data-testid="sticky-book-btn"
        className="btn-rose flex items-center justify-center gap-2 rounded-full bg-rose-800 text-white text-sm py-3.5 w-full"
      >
        <CalendarCheck className="w-4 h-4" />
        Marcar consulta · desde 45€
      </Link>
    </div>
  );
};
